(function() {
  // Remove no-js class as soon as possible
  document.documentElement.classList.remove('no-js');

  // Utility to read cookies
  const getCookieValue = name => (
    document.cookie.match('(^|;)\s*' + name + '\s*=\s*([^;]+)')?.pop() || ''
  );

  // Dark mode toggle based on theme settings
  
    if (getCookieValue('darkmode') === 'on') {
      document.documentElement.classList.add('day-switched');
    }
  

  // If header background equals dropdown color, mark cart icon
  
    const initCartColor = () => {
      const cartEl = document.getElementById('cart');
      if (cartEl) cartEl.classList.add('initial-colors');
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartColor);
    } else {
      initCartColor();
    }
  

})();